import {
  Box,
  CardMedia,
  Grid,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";

export default function BlogList({ blogs }) {
  return (
    <Grid container spacing={3}>
      {blogs.map((blog) => (
        <Grid item xs={12} key={blog.id}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              alignItems: "center",
              gap: 3,
              p: 3,
              borderRadius: 3,
              boxShadow: 4,
              transition: "box-shadow 0.3s",
              "&:hover": { boxShadow: 6 },
              bgcolor: "background.paper",
            }}
          >
            {/* Image */}
            <Box sx={{ flex: "1 1 40%", width: "100%" }}>
              <CardMedia
                component="img"
                image={blog.image}
                alt={blog.title}
                sx={{
                  boxShadow: "0 10px 20px rgba(0,0,0,0.3)",
                  borderRadius: 5,
                  width: "100%",
                  height: { xs: 180, sm: 250, md: 300 },
                  objectFit: "cover",
                }}
              />
            </Box>
            {/* Title & Details */}
            <Box sx={{ flex: "1 1 60%" }}>
              <Typography
                variant="h5"
                fontWeight="bold"
                color="primary"
                sx={{
                  textDecoration: "none",
                  "&:hover": { color: "secondary.main" },
                }}
              >
                {blog.title}
              </Typography>
              <List>
                {blog.points.map((point, index) => (
                  <ListItem
                    key={index}
                    sx={{
                      pl: 0,
                      textDecoration: "none",
                      "&:hover": { color: "secondary.main" },
                    }}
                  >
                    <ListItemText primary={`• ${point}`} />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
}
